import { ApplicationType } from '@/contexts/dynamic-config';
import { DEFAULT_ORDER_DOMAINS } from '@/contexts/new-order-context';
import { DraftOrdersQuery, DraftOrdersQueryVariables } from '@/types';
import { gql } from '@apollo/client';
import { ORDER_FRAGMENT } from '@/contexts/new-order-context-queries';
import { UNPLACED_ORDER_STATUSES } from '@domain/fulfillment-settings/blocs/order-availability';
import { useGetDynamicConfigValueForChat } from '@/hooks/use-dynamic-config-value';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const DRAFT_ORDERS_QUERY = gql`
  query DraftOrders(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $unplacedOrderStatuses: [OrderStatus!]!
    $orderDomains: [OrderDomain!]!
  ) {
    getOrders(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      filters: {
        order_domains: $orderDomains
        statuses: $unplacedOrderStatuses
      }
    ) {
      order {
        ...NewOrder_OrderFields
      }
    }
  }

  ${ORDER_FRAGMENT}
`;

export const useDraftOrders = ({
  restaurantUUID,
  supplierUUID,
  chatUUID,
  skip,
}: {
  chatUUID: string;
  restaurantUUID: string;
  skip?: boolean;
  supplierUUID: string;
}) => {
  const { getDynamicConfigValueForChat } = useGetDynamicConfigValueForChat();

  const isCatalogLimited =
    getDynamicConfigValueForChat(chatUUID, 'application_type') ===
    ApplicationType.CATALOG_ONLY;

  const { data, loading, refetch, hasResponse } = useWrappedQuery<
    DraftOrdersQuery,
    DraftOrdersQueryVariables
  >(DRAFT_ORDERS_QUERY, {
    fetchPolicy: 'network-only',
    skip: skip || !restaurantUUID || !supplierUUID || isCatalogLimited,
    variables: {
      orderDomains: DEFAULT_ORDER_DOMAINS,
      restaurantUUID: restaurantUUID!,
      supplierUUID: supplierUUID!,
      unplacedOrderStatuses: UNPLACED_ORDER_STATUSES,
    },
  });

  return {
    data,
    hasResponse,
    loading,
    refetch,
  };
};
